import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async findAllPorProgramaUniversidadVerificacion(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('inscripciones-excel/programa-universidad-verificacion'), {
      params: opciones.params,
      responseType: 'arraybuffer',
    });
  },
};
